import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { EInvoicesListPage } from "../../pages/e-nvoices-list";
import { HomePage } from "../../pages/home";
import { NotFoundPage } from "../../pages/notfound";
import PAGE from "./page";

export default function Router() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route
          path={`${PAGE.INVOICESlIST}/:policynumber`}
          component={EInvoicesListPage}
          exact
        />
        <Route path={`${PAGE.HOME}/:policynumber`} component={HomePage} exact />
        <Route path="*" component={NotFoundPage} exact />
      </Switch>
    </BrowserRouter>
  );
}
